module.exports = __webpack_public_path__ + "1a0c0c1227b432572dcfbe1c6ca66b6f.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-600.woff2
// module id = 172
// module chunks = 1